"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _ViewsUnauthorize = _interopRequireDefault(require("@rsuite/icon-font/lib/application/ViewsUnauthorize"));

// Generated by script, don't edit it please.
var ViewsUnauthorize = (0, _createSvgIcon["default"])({
  as: _ViewsUnauthorize["default"],
  ariaLabel: 'views unauthorize',
  category: 'application',
  displayName: 'ViewsUnauthorize'
});
var _default = ViewsUnauthorize;
exports["default"] = _default;
module.exports = exports.default;